import { Result } from 'antd';
import { FC } from 'react';

const NotFoundPage: FC = () => {
	return (
		<Result
			status="404"
			subTitle="Page not found"
		/>
	);
};

export default NotFoundPage;
